var _style, _ellipse, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMercuryLampOutput({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mercury Lamp Output") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 8,
    cy: 7.9,
    rx: 5.5,
    ry: 5.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.7,
    y: 0.1,
    className: "st1",
    width: 0.6,
    height: 2.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.7,
    y: 13.4,
    className: "st1",
    width: 0.6,
    height: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 6.7,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 22.5702 -6.7702)",
    className: "st1",
    width: 0.6,
    height: 2.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 7,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 9.5223 6.8947)",
    className: "st1",
    width: 0.6,
    height: 2.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercuryLampOutput);
export default __webpack_public_path__ + "static/media/MercuryLampOutput.14204f4a6f65b9d0c3d265f005aee03d.svg";
export { ForwardRef as ReactComponent };